import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'react-bootstrap';
import { useDeleteJob } from '../../hooks/useJobs';

function ConfirmDeleteJobDialog({ job, setJobs, show, closeDialog }) {

    ConfirmDeleteJobDialog.propTypes = {
        job: PropTypes.object,
        setJobs: PropTypes.func,
        show: PropTypes.bool,
        closeDialog: PropTypes.func
    }

    const { deleteJob, loading } = useDeleteJob();

    const handleDelete = () => {
        deleteJob(job);
        setJobs(prevJobs => prevJobs.filter(j => j.id !== job.id));
        closeDialog();
    };

    const jobName = job.valveName + (job.taskName ? " " + job.taskName : "");

    return (
        <Modal show={show} onHide={closeDialog}>
            <Modal.Header closeButton>
                <Modal.Title>
                    Clear Job
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Are you sure you want to clear this job {jobName}?</p>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={handleDelete}>
                    Ok
                </Button>
                <Button variant="secondary" onClick={closeDialog}>
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ConfirmDeleteJobDialog;